import type { FormWorker } from '../FormWorker'

export const employeesStatusReducer = (
    employeesStatus: FormWorker.EmployeesStatus,
    action: FormWorker.ActionEmployeesStatus
): FormWorker.EmployeesStatus => {
    return {
        ...employeesStatus,
        [action.name]: action.type,
    }
}
